import {Box, Button, Stack, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../auth/AuthContext";

const AccessDeniedPage: React.FC = () => {
    const {t: translate} = useTranslation();
    const navigate = useNavigate();
    const {isAuthenticated} = useAuth();

    return (
        <Box
            sx={{
                minHeight: "calc(100vh - 64px)",
                display: "grid",
                placeItems: "center",
                px: 3,
            }}
        >
            <Stack spacing={2} sx={{maxWidth: 560, textAlign: "center", alignItems: "center"}}>
                <Typography variant="overline" color="text.secondary" sx={{letterSpacing: 1.6, fontWeight: 700}}>
                    {translate("accessDenied.eyebrow")}
                </Typography>
                <Typography variant="h3" sx={{fontWeight: 800}}>
                    {translate("accessDenied.title")}
                </Typography>
                <Typography color="text.secondary">{translate("accessDenied.description")}</Typography>
                <Button variant="contained" onClick={() => navigate(isAuthenticated ? "/" : "/login")} sx={{mt: 1}}>
                    {translate(isAuthenticated ? "accessDenied.backToHome" : "accessDenied.goToLogin")}
                </Button>
            </Stack>
        </Box>
    );
};

export default AccessDeniedPage;
